import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import axios from 'axios';
import PageHero from '../../components/PageHero';
import './PublicationsPage.css';
import publicationsHeroImg from '../../Assets/Image/Publications.webp';
import { publications as defaultPublications } from '../../data/publicationsData';
import SEO from '../../components/SEO';

const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000';

const PublicationsPage = () => {
  const [publications, setPublications] = useState(defaultPublications);

  useEffect(() => {
    const fetchList = async () => {
      try {
        const res = await axios.get(`${API_BASE_URL}/api/publications`);
        if (Array.isArray(res.data.publications) && res.data.publications.length > 0) {
          setPublications(res.data.publications);
        }
      } catch (err) {
        console.error(err);
      }
    };
    fetchList();
  }, []);

  return (
    <div className="publications-page">
      <SEO
        title="Publications"
        description="Insights and practical guides from Whales Advisory across capital markets, M&A, privacy, fintech, real estate, and employment."
        canonicalPath="/publications"
        type="website"
      />
      <PageHero title="Publications" imagePath={publicationsHeroImg} />

      <motion.section
        className="publications-content"
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.2 }}
        transition={{ duration: 0.7, ease: 'easeOut' }}
      >
        <div className="container">
          <div className="publications-grid">
            {publications.map((pub) => (
              <article key={pub.id} className="publication-card">
                <div className="publication-card-header">
                  <span className="publication-category">{pub.category}</span>
                  <span className="publication-date">{pub.date}</span>
                </div>
                <h3 className="publication-title">{pub.title}</h3>
                <p className="publication-summary">{pub.summary}</p>
                <Link to={`/publications/${pub.id}`} className="publication-link">
                  Read More →
                </Link>
              </article>
            ))}
          </div>
        </div>
      </motion.section>
    </div>
  );
};

export default PublicationsPage;
